export const SideMenuItems = [
  {
    MenuItem: 'General',
    id: 'general',
    AccordionItems: [
      {
        AccordionHeader: 'What is CIID? ',
        AccordionBody:
          'CIID is Climate Impact Investment Decisions to unlock and de-risk climate capital for carbon projects in the transition to Net Zero. Imagine one platform that allows to measure GHG baselines for organization, plan and implement carbon projects, monitor progress and quality, and lastly manage carbon asset portfolio for retirements or trade. The seamless system for all organizations to reach Net Zero. ',
      },
      {
        AccordionHeader: 'How to use CIID?',
        AccordionBody:
          'CIID allows you to view number of projects and live feed of updates from the registry in the dashboard page, while the projects page allows to search carbon projects across the world, filtered by project type, or crediting period. You can find the projects you are researching quickly, save them for review later. The due diligence data on community, planet (environment), technical (additionality, leakage, permance, co-benefits), legal, and financial instruments are provided for the location. This allows to evaluate existing projects quality for references or trade requirements.',
      },
      {
        AccordionHeader: 'How to use CIID projects?',
        AccordionBody:
          'CIID projects allows you to search for all the carbon projects across the globe, and gain insights into project details and due diligence parameters. Save the project with the button at the top of the page, to keep track of your favorite projects.',
      },
      {
        AccordionHeader: 'Does CIID have all the carbon projects? ',
        AccordionBody:
          'Our data holds 22 thousand carbon projects gathered from 7 registries - Verra, Gold Standard, CDM, Global Carbon Council, American Carbon Registry, Biocarbon and Cercarbano. In the application we have 6.5 thousand projects listed with location data. We are updating the master dataset of carbon projects to full capacity by May 3rd. ',
      },
      {
        AccordionHeader: 'How old is the data in CIID?',
        AccordionBody:
          'The data upto February 2024 is updated in CIID. Our goal is to have real time updates in the future of projects, and transactions.  ',
      },
      {
        AccordionHeader: 'How can I record a bug or request a feature in CIID? ',
        AccordionBody: 'Please contact gagan@proclime.world for any queries and suggestions.',
      },
    ],
  },
  {
    MenuItem: 'Data Sources',
    id: 'Data sources',
    AccordionItems: [
      {
        AccordionHeader: 'Where are carbon projects data coming from?',
        AccordionBody:
          'Our data holds 22 thousand carbon projects gathered from 7 registries - Verra, Gold Standard, CDM, Global Carbon Council, American Carbon Registry, Biocarbon and Cercarbano. In the application we have 6.5 thousand projects listed with location data. We are updating the master dataset of carbon projects to full capacity by May 3rd. ',
      },

      {
        AccordionHeader: 'What are the sources of land use data?',
        AccordionBody:
          'We source data for Landuse from Copernicus Climate data store, Land monitoring service ProBA-V and ESRI Landcover 10m resolution',
      },
      {
        AccordionHeader: 'Does CIID help with monitoring projects?',
        AccordionBody:
          'Yes. CIID will ingest satellite data over a time period to help with ex-ante assessments, and during implementation cycle for quality control. ',
      },
    ],
  },
  {
    MenuItem: 'Upcoming features',
    id: 'features',
    AccordionItems: [
      {
        AccordionHeader: 'Due diligence data for technical parameters in carbon projects',
        AccordionBody:
          'Additionality, permanence, leakage, and co-benefits datasets for project locations made available by ingesting all project available project design documents',
      },
      {
        AccordionHeader: 'Project recommendations',
        AccordionBody:
          'Our internal carbon credit yield model will estimate best sites to build and create carbon projects for all types of carbon projects. Imagine searching for the location Tamil Nadu or Mangroves in the search box to get a list of potential sites where mangroves are suitable for conservation type or reforestation type projects.',
      },
      {
        AccordionHeader: 'How are these recommendations made?',
        AccordionBody:
          'Using the same mangrove example, a data and model based approach was used to analyse historical degradataion, land use, size of deforestation, biodiversity, climate risks to identify suitable sites for conservation and reforestation. This model and data based approach was compared with the traditional human expert based assessments of site suitability. We achieved an 85% accuracy for prediction, with most of the sites chosen for conservation and reforestation was found by our algorithm. We plan to scale this to all types of carbon projects by using the expert advice and parameter selection to refine our recommendations, reduce operational inputs to finalize sites, and streamline tasks towards creative project design.',
      },
      {
        AccordionHeader: 'Automated project design document (PDD) builder',
        AccordionBody:
          'The rich data architecture, is used to build a large language model for carbon projects, akin to a chatgpt generative AI tool. Selecting a recommendation project and methodology from a registry, the document builder will populate the PDD based on the chosen methodoogy, data for all sections of the PDD, and graphical elements to drag and drop to the screen',
      },
      {
        AccordionHeader: 'Onboard clients into the digital world',
        AccordionBody:
          'Our clients require high quality projects to be designed with financial viability for their Net Zero ambiiton. Our tools helps you helps them better, and in the next iteration, offer them a digital system to login and get the service through the platform. ',
      },
      {
        AccordionHeader: 'Investment models',
        AccordionBody:
          'Real time analysis of climate capital flows, and new instruments helps to determine the best capital structure for different carbon projects',
      },
    ],
  },
];
